import React from 'react';

const normalizeSource = source => {
  if (typeof source === 'string') return { src: source };
  return source || { src: '' };
};

export default function ResponsiveImage({
  source,
  src,
  srcSet,
  sizes,
  alt = '',
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
  width,
  height,
  ...props
}) {
  const descriptor = normalizeSource(source || { src, srcSet, sizes, width, height });

  return (
    <img
      src={descriptor.src || src}
      srcSet={descriptor.srcSet || srcSet}
      sizes={descriptor.sizes || sizes}
      alt={alt}
      loading={loading}
      fetchpriority={fetchPriority}
      decoding={decoding}
      width={descriptor.width || width}
      height={descriptor.height || height}
      {...props}
    />
  );
}
